import { TBucketId } from 'libs/services/src/lib/capacitor/bucket-storage.types';
import { TShiftInfo } from '../api.types';
import {
  IRejectList,
  TDefectiveOperationIssueAndSilhouetteMarkingInfo,
  TOperationAnsIssue,
} from '../master-data.types';
import { Subject } from '../pre-settings.types';
import { TSampleModel } from '../roaming-qc/audit-dto.types';
import {
  TBctxItem,
  TBctxItemWithoutSize,
  TBctxItemWithoutSizeAndBctxKey,
  TQcActionItem,
  TBCTXKeys,
  TEventValidation,
  TEventAddtionMoreActions,
  TKeyDisplayMap,
  TActionItemType,
} from './api.types';
import { TDefectiveFromServer } from './server-defectives.types';
import { TSingleAuditDetail } from '../aql/aql.types';
type TCheckInActionType = 'CHECK_IN';
type TUndoCheckInActionType = 'UNDO_CHECK_IN';
type TFttActionType = 'FTT';
type TUndoFttActionType = 'UNDO_FTT';
type TDefectiveActionType = 'DEFECTIVE';
type TUndoDefectiveActionType = 'UNDO_DEFECTIVE';
type TRejectedActionType = 'REJECTED';
type TUndoRejectedActionType = 'UNDO_REJECTED';
type TReworkedFromDefectiveActionType = 'REWORKED_FROM_DEFECTIVE';
type TUndoReworkedFromDefectiveActionType = 'UNDO_REWORKED_FROM_DEFECTIVE';
type TRejectedFromDefectiveActionType = 'REJECTED_FROM_DEFECTIVE';
type TUndoRejectedFromDefectiveActionType = 'UNDO_REJECTED_FROM_DEFECTIVE';
export type TDefectiveResolutionActionType = TReworkedFromDefectiveActionType | TRejectedFromDefectiveActionType;
export type TForwardEventActionType =
  | TCheckInActionType
  | TFttActionType
  | TDefectiveActionType
  | TRejectedActionType
  | TReworkedFromDefectiveActionType
  | TRejectedFromDefectiveActionType;
export type TUndoEventActionType =
  | TUndoCheckInActionType
  | TUndoFttActionType
  | TUndoDefectiveActionType
  | TUndoRejectedActionType
  | TUndoReworkedFromDefectiveActionType
  | TUndoRejectedFromDefectiveActionType;
export type TEventActionType = TForwardEventActionType | TUndoEventActionType;
export type TYET_TO_BE_SYNCED = 'YET_TO_BE_SYNCED';
type TSYNCED = 'SYNCED';
type TSERVER_ERROR = 'SERVER_ERROR';
type TSYNCED_WITH_SUCCESS = 'SYNCED_WITH_SUCCESS';
type TVALIDATION_ERROR = 'VALIDATION_ERROR';
type TVALIDATION_ERROR_FOR_ALL_EVENTS = 'TVALIDATION_ERROR_FOR_ALL_EVENTS';

export type TEventStationDetails = {
  subject: Subject;
  shift: TShiftInfo;
};
export type TBctxKeysToDisplayMap = Record<TBCTXKeys, string>;
export const BCTX_KEYS_TO_DISPLAY_MAP: TBctxKeysToDisplayMap = {
  buyer: 'BUYER',
  po: 'PO',
  style: 'STYLE',
  product_type: 'PRODUCT TYPE',
  color: 'COLOR',
  product_category: 'PRODUCT CATEGORY',
  order_ref: 'ERP KEY',
  size: 'SIZE',
  display_piece_tag: 'DISPLAY TAG ID',
  search_id: 'SEARCH ID',
  audit_disName: 'DISPLAY TAG ID',
  bundle_no: 'BUNDLE_NO',
};
export const BCTX_KEYS_TO_FILTER_TITLES: TBctxKeysToDisplayMap = {
  buyer: 'All Buyers',
  po: 'All POs',
  style: 'All Styles',
  product_type: 'All Product Types',
  product_category: 'All Product Categories',
  order_ref: 'All ERP Keys',
  color: 'All Colors',
  size: 'All Sizes',
  display_piece_tag: 'All Display Tags',
  search_id: 'All Search Ids',
  audit_disName: 'All Display Tags',
  bundle_no: 'All Bundle Nos',
};

export type TEventLocation = 'WITH_IN_BCTX' | 'ACROSS_BCTX';
export const UNDO_ERROR_TO_DISPLAY_MESSAGE: Record<TLastEventError, string> = {
  NO_EVENTS_ADDED: 'input_app_event_types.noEventsAdded',
  DEFECT_REJECTED: 'input_app_event_types.defectRejected',
  DEFECT_REWORKED: 'input_app_event_types.defectReworked',
  EVENTS_ADDED_FROM_OTHER_LOCATION: 'input_app_event_types.eventAddedFromOtherLocation',
  SERVER_ERROR: 'input_app_event_types.serverError',
  LIMIT_REACHED: 'input_app_event_types.undoLimitReached',
  HISTORY_CHANGED: 'input_app_event_types.historyChanged',
  HIGHER_ROUND_AVAILABLE: 'input_app_event_types.higherRoundAvailable',
};
export type TLastEventError =
  | 'NO_EVENTS_ADDED'
  | 'LIMIT_REACHED'
  | 'DEFECT_REJECTED'
  | 'DEFECT_REWORKED'
  | 'EVENTS_ADDED_FROM_OTHER_LOCATION'
  | 'SERVER_ERROR'
  | 'HISTORY_CHANGED'
  | 'HIGHER_ROUND_AVAILABLE';
export type TLastEventResultSuccess = {
  status: 'SUCCESS';
  event: TForwardBulkEvent;
};
export type TLastEventResultFailure = {
  status: 'FAILURE';
  error: TLastEventError;
};
export type TLastEventResult = TLastEventResultFailure | TLastEventResultSuccess;
export type TBulkEventBackgroundMetadata = {
  groupId: string;
  remainingRetriesCount: number;
  bulkEventStatus: TYET_TO_BE_SYNCED | TSYNCED | TSERVER_ERROR | TVALIDATION_ERROR_FOR_ALL_EVENTS;
  errorDetails?: any;
  syncedTime?: number;
};
type TBulkEventMetadata = {
  groupId: string;
  eventTime: number;
  stationDetails: TEventStationDetails;
  location: TEventLocation;
};

export type TEventBctxDetails = {
  businessContextDetailsWithoutSize: TBctxItemWithoutSize[];
  size: string;
  count: number;
  bctxKey: string;
  newBctxDetails?: {
    businessContextDetailsWithoutSize: TBctxItemWithoutSize[];
    bctxKey?: string;
    groupedHeaderInfo?: TKeyDisplayMap[];
  };
};
export type TSycedEventStatus = TSYNCED_WITH_SUCCESS | TVALIDATION_ERROR | TSERVER_ERROR;
export type TEventBackgroundMetadata = {
  v_id: string;
  status: TYET_TO_BE_SYNCED | TSYNCED_WITH_SUCCESS | TVALIDATION_ERROR | TSERVER_ERROR;
  errorDetails?: TEventValidation['failure_info'];
  eventId: number;
};
export type TEventCommonDetails = {
  bctxDetails: TEventBctxDetails;
  linked_v_id?: string;
  eventTime: number;
  v_id: string;
};

type TUndoEventMetadata = {
  forwardEventTime: number;
};

export type TDefectiveInfo = {
  defectives: TDefectiveOperationIssueAndSilhouetteMarkingInfo[];
  round: number;
  id: string;
  displayList: {
    operation: string;
    concatinatedIssues: string;
  }[];
};

export type TRejectedInfo = {
  reasons: IRejectList[];
};

export type TSingleEventStatus = {
  eventBackgroundMetadata: TEventBackgroundMetadata;
};

export type TSingleCheckInEventWithoutStatus = {
  type: 'FORWARD_EVENT';
  actionType: TCheckInActionType;
  eventInfo: TEventCommonDetails;
};
export type TSingleCheckInEvent = TSingleCheckInEventWithoutStatus & TSingleEventStatus;

export type TSingleUndoCheckInEventWithoutStatus = {
  type: 'UNDO_EVENT';
  actionType: TUndoCheckInActionType;
  eventInfo: TEventCommonDetails;
  undoMetadata: TUndoEventMetadata;
};
export type TSingleUndoCheckInEvent = TSingleUndoCheckInEventWithoutStatus & TSingleEventStatus;

export type TSingleFttEventWithoutStatus = {
  type: 'FORWARD_EVENT';
  actionType: TFttActionType;
  eventInfo: TEventCommonDetails;
};
export type TSingleFttEvent = TSingleFttEventWithoutStatus & TSingleEventStatus;

export type TSingleUndoFttEventWithoutStatus = {
  type: 'UNDO_EVENT';
  actionType: TUndoFttActionType;
  eventInfo: TEventCommonDetails;
  undoMetadata: TUndoEventMetadata;
};
export type TSingleUndoFttEvent = TSingleUndoFttEventWithoutStatus & TSingleEventStatus;

export type TDefectiveInfoWithLinkedVId = {
  event: TSingleDefectiveEvent | TDefectiveFromServer;
  linked_v_id: string | undefined;
};
export type TPerPieceDefectiveInfoWithLinkedVId = {
  eventInfo:
    | {
        type: 'SERVER_DEFECTIVE';
        event: TDefectiveFromServer;
      }
    | {
        type: 'USER_EVENT';
        event: TBulkCountEvent;
      };
  linked_v_id: string | undefined;
};
export type TSingleDefectiveEventWithoutStatus = {
  type: 'FORWARD_EVENT';
  subType: 'DEFECTIVE' | 'DEFECTIVE_FROM_DEFECTIVE';
  actionType: TDefectiveActionType;
  eventInfo: TEventCommonDetails;
  defectivesInfo: TDefectiveInfo;
  recentDefectMetaData: TOperationAnsIssue[];
  sourceDefectiveCreatedTime: number;
  imageId: null | TBucketId;
};
export type TSingleDefectiveEvent = TSingleDefectiveEventWithoutStatus & TSingleEventStatus;
export const OmittedKeys = ['search_id', 'display_piece_tag', 'audit_disName', 'bundle_no'];
export type TSingleUndoDefectiveEventWithoutStatus = {
  type: 'UNDO_EVENT';
  subType: 'UNDO_DEFECTIVE' | 'UNDO_DEFECTIVE_FROM_DEFECTIVE';
  actionType: TUndoDefectiveActionType;
  eventInfo: TEventCommonDetails;
  defectivesInfo: TDefectiveInfo;
  undoMetadata: TUndoEventMetadata;
  sourceDefectiveCreatedTime: number;
  imageId: null | TBucketId;
};
export type TSingleUndoDefectiveEvent = TSingleUndoDefectiveEventWithoutStatus & TSingleEventStatus;
export type TSingleRejectedEventWithoutStatus = {
  type: 'FORWARD_EVENT';
  actionType: TRejectedActionType;
  eventInfo: TEventCommonDetails;
  rejectedInfo: TRejectedInfo;
  imageId: null | TBucketId;
};
export type TSingleRejectedEvent = TSingleRejectedEventWithoutStatus & TSingleEventStatus;
export type TSingleUndoRejectedEventWithoutStatus = {
  type: 'UNDO_EVENT';
  actionType: TUndoRejectedActionType;
  eventInfo: TEventCommonDetails;
  rejectedInfo: TRejectedInfo;
  undoMetadata: TUndoEventMetadata;
  imageId: null | TBucketId;
};
export type TSingleUndoRejectedEvent = TSingleUndoRejectedEventWithoutStatus & TSingleEventStatus;
export type TSingleReworkedEventFromDefectivesWithoutStatus = {
  type: 'FORWARD_EVENT';
  actionType: TReworkedFromDefectiveActionType;
  eventInfo: TEventCommonDetails;
  defectivesInfo: TDefectiveInfo;
  sourceDefectiveCreatedTime: number;
  imageId: null | TBucketId;
};
export type TSingleReworkedEventFromDefectives = TSingleReworkedEventFromDefectivesWithoutStatus & TSingleEventStatus;
export type TSingleUndoReworkedEventFromDefectivesWithoutStatus = {
  type: 'UNDO_EVENT';
  actionType: TUndoReworkedFromDefectiveActionType;
  eventInfo: TEventCommonDetails;
  defectivesInfo: TDefectiveInfo;
  undoMetadata: TUndoEventMetadata;
  sourceDefectiveCreatedTime: number;
  imageId: null | TBucketId;
};
export type TSingleUndoReworkedEventFromDefectives = TSingleUndoReworkedEventFromDefectivesWithoutStatus &
  TSingleEventStatus;
export type TSingleRejectedEventFromDefectivesWithoutStatus = {
  type: 'FORWARD_EVENT';
  actionType: TRejectedFromDefectiveActionType;
  eventInfo: TEventCommonDetails;
  defectivesInfo: TDefectiveInfo;
  rejectedInfo: TRejectedInfo;
  sourceDefectiveCreatedTime: number;
  imageId: null | TBucketId;
};
export type TSingleRejectedEventFromDefectives = TSingleRejectedEventFromDefectivesWithoutStatus & TSingleEventStatus;
export type TSingleUndoRejectedEventFromDefectivesWithoutStatus = {
  type: 'UNDO_EVENT';
  actionType: TUndoRejectedFromDefectiveActionType;
  eventInfo: TEventCommonDetails;
  defectivesInfo: TDefectiveInfo;
  undoMetadata: TUndoEventMetadata;
  rejectedInfo: TRejectedInfo;
  sourceDefectiveCreatedTime: number;
  imageId: null | TBucketId;
};

export type TSingleUndoRejectedEventFromDefectives = TSingleUndoRejectedEventFromDefectivesWithoutStatus &
  TSingleEventStatus;

export type TDefectiveReleatedEvent =
  | TSingleDefectiveEvent
  | TSingleUndoDefectiveEvent
  | TSingleReworkedEventFromDefectives
  | TSingleUndoReworkedEventFromDefectives
  | TSingleRejectedEventFromDefectives
  | TSingleUndoRejectedEventFromDefectives;

export type TForwardSingleEventWithoutStatus =
  | TSingleCheckInEventWithoutStatus
  | TSingleFttEventWithoutStatus
  | TSingleDefectiveEventWithoutStatus
  | TSingleRejectedEventWithoutStatus
  | TSingleReworkedEventFromDefectivesWithoutStatus
  | TSingleRejectedEventFromDefectivesWithoutStatus;
export type TForwardSingleEvent =
  | TSingleCheckInEvent
  | TSingleFttEvent
  | TSingleDefectiveEvent
  | TSingleRejectedEvent
  | TSingleReworkedEventFromDefectives
  | TSingleRejectedEventFromDefectives;

export type TUndoSingleEventWithoutStatus =
  | TSingleUndoCheckInEventWithoutStatus
  | TSingleUndoFttEventWithoutStatus
  | TSingleUndoDefectiveEventWithoutStatus
  | TSingleUndoRejectedEventWithoutStatus
  | TSingleUndoReworkedEventFromDefectivesWithoutStatus
  | TSingleUndoRejectedEventFromDefectivesWithoutStatus;
export type TUndoSingleEvent =
  | TSingleUndoCheckInEvent
  | TSingleUndoFttEvent
  | TSingleUndoDefectiveEvent
  | TSingleUndoRejectedEvent
  | TSingleUndoReworkedEventFromDefectives
  | TSingleUndoRejectedEventFromDefectives;
export type TGenericEvent<T> = {
  actionType: TSingleCountEvent['actionType'];
  eventInfo: T;
};
export type TSingleCountEvent = TForwardSingleEvent | TUndoSingleEvent;
export type TSingleEvent =
  | TSingleCountEvent
  | TMemberAdditionSingleEvent
  | TBCTXChangeSingleEvent
  | TBundleQcCompleteSingleEvent
  | TBundleQcMissingSingleEvent
  | TRoamingQcSingleEvent
  | TAqlSingleEvent;
export type TUndoBulkEventMetadata = {
  forwardEventGroupId: string;
};
export type TBulkEventStatus = {
  backgroundMetadata: TBulkEventBackgroundMetadata;
};
export type TForwardBulkEventWithoutStatus = {
  type: 'FORWARD_BULK_EVENT';
  metadata: TBulkEventMetadata;
  events: TForwardSingleEventWithoutStatus[];
};
export type TForwardBulkEvent = TBulkEventStatus & {
  type: 'FORWARD_BULK_EVENT';
  metadata: TBulkEventMetadata;
  events: TForwardSingleEvent[];
};

export type TUndoBulkEvent = TBulkEventStatus & {
  type: 'UNDO_BULK_EVENT';
  metadata: TBulkEventMetadata;
  undoMetadata: TUndoBulkEventMetadata;
  events: TUndoSingleEvent[];
};
export type TUndoBulkEventWithoutStatus = {
  type: 'UNDO_BULK_EVENT';
  metadata: TBulkEventMetadata;
  undoMetadata: TUndoBulkEventMetadata;
  events: TUndoSingleEventWithoutStatus[];
};
export type TBulkCountEvent = TForwardBulkEvent | TUndoBulkEvent;
export type TBulkCountEventWithoutStatus = TForwardBulkEventWithoutStatus | TUndoBulkEventWithoutStatus;
export type TActivityLogEvent = TForwardBulkEvent | TUndoBulkEvent | TMemberAdditionEvent;
export type TBulkEvent =
  | TForwardBulkEvent
  | TUndoBulkEvent
  | TBctxChangeEvent
  | TMemberAdditionEvent
  | TRoamingQcEvent
  | TBundleQcCompleteEvent
  | TBundleQcMissingEvent
  | TAqlEvent;
export type TBulkEventWithoutStatus =
  | TForwardBulkEventWithoutStatus
  | TBundleQcCompleteEventWithoutStatus
  | TBundleQcMissingEventWithoutStatus
  | TUndoBulkEventWithoutStatus
  | TBctxChangeEventWithoutStatus
  | TMemberAdditionEventWithoutStatus
  | TRoamingQcEventWithoutStatus;
export type TSyncEventStatus = 'ALL_SYNCED' | 'NO_INTERNET' | 'SERVER_ERROR' | 'YET_TO_BE_SYNCED' | 'UNKNOWN_ERROR';
export type TSyncEventsDTO = {
  bulkEvents: TBulkEvent[];
  failedBulkEventsIndexes: number[];
  lastBatchSyncStatus: TSyncEventStatus;
};
export type TToBeSyncedEventsDTO = {
  toBeSyncedBulkEvents: TBulkEvent[];
  groupIdToIndexMap: Record<string, number>;
  vIdToGroupIdMap: Record<string, string>;
};
export type TRestoreBackedUpBctx = {
  wipOnly: boolean;
  actualsOnly: boolean;
  chainWithLoadMasterdataList: boolean;
  hideLoader?: boolean;
};
export type TUndoDTO = {
  actionType: TActionItemType;
  selectedBctx: TBctxItemWithoutSizeAndBctxKey;
  undoLimit: number;
};
export type TPerPieceQcUntoDTO = {
  actionType: TQcActionItem['type'];
  undoLimit: number;
  eventAdditionMoreActions: TEventAddtionMoreActions;
  serverDefectivesDataUndo: TServerDefectivesDataUndo;
};

export type TServerDefectivesDataUndo = {
  serverDefectives: TDefectiveFromServer[];
  latestServerDefectivesSyncTime: number;
};

export type TPerPieceLineInUndoDTO = {
  bulkEvent: TForwardBulkEvent;
  eventAdditionMoreActions: TEventAddtionMoreActions;
  poSplitUndoWipOverrideDetails?: TBctxItem[];
};
export type TBCTXChangeSingleEventWithoutStatus = {
  type: TBCTXChangeEventType;
  actionType: TBCTXChangeEventType;
  eventInfo: {
    oldBctxItemListWithoutSize: TBctxItemWithoutSize[];
    oldSize?: string;
    newBctxItemListWithoutSize: TBctxItemWithoutSize[];
    newSize?: string;
    v_id: string;
    linked_v_id?: string;
    eventTime: number;
  };
};
export type TBCTXChangeSingleEvent = TBCTXChangeSingleEventWithoutStatus & TSingleEventStatus;
export type TBCTXChangeEventType = 'BCTX_CHANGE_EVENT';
export type TBctxChangeEvent = TBulkEventStatus & {
  type: TBCTXChangeEventType;
  metadata: TBulkEventMetadata;
  events: TBCTXChangeSingleEvent[];
};
export type TBctxChangeEventWithoutStatus = {
  type: TBCTXChangeEventType;
  metadata: TBulkEventMetadata;
  events: TBCTXChangeSingleEventWithoutStatus[];
};
export type TBundleQcCompleteEventType = 'BUNDLE_QC_COMPLETE_EVENT';
export type TBundleQcCompleteSingleEventWithoutStatus = {
  type: TBundleQcCompleteEventType;
  actionType: TBundleQcCompleteEventType;
  eventInfo: {
    bctxDetails: {
      businessContextDetailsWithoutSize: TBctxItemWithoutSize[];
      size?: string;
    };
    v_id: string;
    linked_v_id?: string;
    eventTime: number;
    bundleQty: number;
  };
};
export type TBundleQcCompleteSingleEvent = TBundleQcCompleteSingleEventWithoutStatus & TSingleEventStatus;
export type TBundleQcCompleteEvent = TBulkEventStatus & {
  type: TBundleQcCompleteEventType;
  metadata: TBulkEventMetadata;
  events: TBundleQcCompleteSingleEvent[];
};
export type TBundleQcCompleteEventWithoutStatus = {
  type: TBundleQcCompleteEventType;
  metadata: TBulkEventMetadata;
  events: TBundleQcCompleteSingleEventWithoutStatus[];
};
export type TBundleQcMissingEventType = 'BUNDLE_QC_MISSING_EVENT';
export type TBundleQcMissingSingleEventWithoutStatus = {
  type: TBundleQcMissingEventType;
  actionType: TBundleQcMissingEventType;
  eventInfo: {
    bctxDetails: {
      businessContextDetailsWithoutSize: TBctxItemWithoutSize[];
      size?: string;
    };
    v_id: string;
    linked_v_id?: string;
    eventTime: number;
    bundleQty: number;
    missingQty: number;
  };
};
export type TBundleQcMissingSingleEvent = TBundleQcMissingSingleEventWithoutStatus & TSingleEventStatus;
export type TBundleQcMissingEvent = TBulkEventStatus & {
  type: TBundleQcMissingEventType;
  metadata: TBulkEventMetadata;
  events: TBundleQcMissingSingleEvent[];
};
export type TBundleQcMissingEventWithoutStatus = {
  type: TBundleQcMissingEventType;
  metadata: TBulkEventMetadata;
  events: TBundleQcMissingSingleEventWithoutStatus[];
};
export type TMemberAdditionType = 'operators' | 'helpers';
export type TMemberAdditionData = {
  type: TMemberAdditionType;
  count: number;
  displayName: string;
};
export type TMemberAdditionInfo = {
  eventType: string;
  list: TMemberAdditionData[];
};
export const ColourGrades = {
  RED: 'red',
  YELLOW: 'yellow',
  GREEN: 'green',
};
export const DefectTypes = {
  CRITICAL: 'critical',
  MAJOR: 'major',
  MINOR: 'minor',
};
export type TAuditDTOModel = {
  bctxItemListWithoutSize: TBctxItemWithoutSize[];
  size: string;
  cycle_id: string;
  round: number;
  operator: string;
  operation: string;
  samples: TSampleModel[];
  colour: string;
};
export type TTransactionAuditDTOModel = {
  audit_id: string;
  shift: string;
  bctxItems: TBctxItem[];
  cycle_id: string;
  round: number;
  operator: string;
  operation: string;
  samples: TSampleModel[];
  grade: string;
  datetime: number;
  subject: string;
  record_category: string;
};
export type TRoamingQcSingleEventWithoutStatus = {
  type: TRoamingQcEventType;
  actionType: TRoamingQcEventType;
  eventInfo: {
    auditDetails: TAuditDTOModel;
    v_id: string;
    linked_v_id?: string;
    eventTime: number;
  };
};
export type TRoamingQcSingleEvent = TRoamingQcSingleEventWithoutStatus & TSingleEventStatus;
export type TRoamingQcEventType = 'ROAMING_QC_EVENT';
export type TRoamingQcEvent = TBulkEventStatus & {
  type: TRoamingQcEventType;
  metadata: TBulkEventMetadata;
  events: TRoamingQcSingleEvent[];
};
export type TRoamingQcEventWithoutStatus = {
  type: TRoamingQcEventType;
  metadata: TBulkEventMetadata;
  events: TRoamingQcSingleEventWithoutStatus[];
};

export type TAqlSingleEventWithoutStatus = {
  type: TAqlEventType;
  actionType: TAqlEventType;
  eventInfo: {
    auditDetails: TSingleAuditDetail;
    v_id: string;
    linked_v_id?: string;
    eventTime: number;
  };
};

export type TAqlSingleEvent = TAqlSingleEventWithoutStatus & TSingleEventStatus;
export type TAqlEventType = 'AQL_EVENT';
export type TAqlEvent = TBulkEventStatus & {
  type: TAqlEventType;
  metadata: TBulkEventMetadata;
  events: TAqlSingleEvent[];
};
export type TAqlEventWithoutStatus = {
  type: TAqlEventType;
  metadata: TBulkEventMetadata;
  events: TAqlSingleEventWithoutStatus[];
};

export type TMemberAdditionSingleEventWithoutStatus = {
  type: 'MEMBER_ADDITION_EVENT';
  actionType: 'MEMBER_ADDITION_EVENT';
  eventInfo: {
    memberAdditionInfo: TMemberAdditionInfo;
    v_id: string;
    linked_v_id?: string;
    eventTime: number;
    newBctxItemListWithoutSize: TBctxItemWithoutSize[];
    newSize?: string;
  };
};
export type TMemberAdditionSingleEvent = TMemberAdditionSingleEventWithoutStatus & TSingleEventStatus;
export type TMemberAdditionEvent = TBulkEventStatus & {
  type: 'MEMBER_ADDITION_EVENT';
  metadata: TBulkEventMetadata;
  events: TMemberAdditionSingleEvent[];
};

export type TActivityLogItemFilterType = TBCTXKeys | 'EVENT' | 'STATUS' | 'DATE';
export type TMemberAdditionEventWithoutStatus = {
  type: 'MEMBER_ADDITION_EVENT';
  metadata: TBulkEventMetadata;
  events: TMemberAdditionSingleEventWithoutStatus[];
};

export type TActivityLogItemFilter = {
  filterType: TActivityLogItemFilterType;
  values: (string | number)[];
};
export type TValidAndInvalidDefectivesInfo = {
  [key: string]: {
    eventList: TDefectiveReleatedEvent[];
    futureValidEventList: TDefectiveReleatedEvent[];
    hasAnyServerErrorEvent: boolean;
    failedEventVIds: Set<string>;
  };
};
export type TValidAndInvalidPerPieceEventsInfo = {
  [key: string]: {
    eventList: TBulkCountEvent[];
    futureValidEventList: TBulkCountEvent[];
    hasAnyServerErrorEvent: boolean;
    failedEventVIds: Set<string>;
  };
};

export type TREQUEST_UndoValidation = {
  subjectKey: string;
  subject: string;
  qty: number;
  filter_range: {
    start: 0;
    end: number;
  };
  window: string;
  wipType: string;
  nonWashWipType: string | null;
  columns: TBctxItem[];
};

export type TRESPONSE_UndoValidation = {
  remaining_qty: number;
  valid: boolean;
};

export type TLastEventDetails = {
  hasServerError: boolean;
  remainingEvent: {
    event: null | TBulkCountEvent;
    modified_v_id?: string;
  };
  firstEvent: null | TBulkCountEvent;
};

export type TLastEventInfoByBctx = {
  hasInitialized: boolean;
  defectiveInfo:
    | {
        isDefective: false;
      }
    | {
        isDefective: true;
        defective: TPerPieceDefectiveInfoWithLinkedVId;
      };
  lastEventInfo:
    | {
        hasLastEvent: false;
      }
    | {
        hasLastEvent: true;
        lastEvent: TLastEventDetails;
      };
};

export type TMasterDataListMetaData = {
  source: 'INIT' | 'RESET' | 'SYNC' | 'UNKNOWN';
};
